// extracted by mini-css-extract-plugin
export default {"roleInput":"RolesAndRatesForm_roleInput__niSZX","rateInput":"RolesAndRatesForm_rateInput__h+AzL"};